import * as React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import css from '@emotion/css'
import Hero from './about/Hero'
import Page from '../components/Page'
import Container from '../components/Container'
import IndexLayout from '../layouts'
import FirstSection from './about/FirstSection'
import SecondSection from './about/SecondSection'
import JustinMegaphone from './about/JustinMegaphone'
import Dog from './about/Dog'
import Contribute from './index/Contribute'
import Join from './index/Join'
import { getEmSize } from '../styles/mixins'
import { breakpoints } from '../styles/variables'

export const RegularP = styled.p``
export const BoldP = styled.p`
  font-weight: 600;
`

const About = () => (
  <IndexLayout>
    <Page>
      <Container>
        <Hero />
        <FirstSection />
        <JustinMegaphone
          css={css`
            height: 645px;
            @media (max-width: ${getEmSize(breakpoints.lg)}em) {
              height: 300px;
              width: 100%;
              img {
                object-fit: contain !important;
              }
            }
          `}
        />
        <SecondSection />
        <Dog
          css={css`
            height: 800px;
          `}
        />
        <Contribute />
        <Join />
      </Container>
    </Page>
  </IndexLayout>
)

export default About
